import React, { Component } from 'react'
import styled from 'styled-components'
import { CommentsApi } from '../../API/api'
import reloadIcon from '../../static/images/icons/reload.png'
import CommentTopBar from './CommentsTopBar'
import CommentForm from './CommentForm'
import CommentList from '../comments/CommentList'
import { GA_Event } from '../Analytics/Analytics'

const Container = styled.div`
margin-top: 40px;
font-size: 23px !important;
display: block;
max-width: 980px;
margin: 20px auto 40px;
display:${props => props.shown ? 'block' : 'none'};
`
const LoadCommentsContainer = styled.div`
text-align:center;
user-select:none;
transition:opacity 1s;
${props => {
        switch (props.state) {
            case 'loading':
                return `
            opacity:.4;
            `
            case 'off':
                return `
            display:none;
            `
            default:
                return '';
        }
    }}
`
const LoadButton = styled.button`
cursor:pointer;
> *{
    vertical-align:middle;
}
span{
    text-align:right;
    margin-right:20px;
    display:inline-block;
    font-size:16px;
    max-width:90px;
}
`
const LoadIcon = styled.div`
will-change:transform;
display:inline-block;
`
class Comments extends Component {
    constructor() {
        super();
        this.showMainForm = this.showMainForm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            isMainFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false },
            inputName: '',
            inputTitle: '',
            inputContent: ''
        }
    }
    showMainForm() {
        GA_Event('Add_Comment', window.location.pathname + window.location.hash);
        this.setState({
            isMainFormActive: true
        });
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        window.setTimeout(() => {
            this.setState({
                formState: this.validateForm()
            });
        }, 0);
    }
    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.formState.valid) {
            alert(this.state.formState.msg);
            return;
        }
        this._submitForm();
        this.setState({
            inputName: '',
            inputTitle: '',
            inputContent: '',
            isMainFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false }
        });
    }
    _submitForm() {
        CommentsApi.add(
            this.state.inputName,
            this.state.inputTitle,
            this.state.inputContent,
            this.props.articleRef
        );
        alert('תודה, קיבלנו את תגובתך ונשתדל לפרסמה בכפוף לשיקולי המערכת.');
    }
    validateForm() {
        let result = {
            msg: '',
            valid: true
        };
        const _name = this.state.inputName;
        const _title = this.state.inputTitle;
        if (_name.length < 1) {
            result.msg = 'חובה להזין שם';
            result.valid = false;
            return result;
        }
        if (_title.length < 1) {
            result.msg = 'חובה להזין כותרת';
            result.valid = false;
            return result;
        }
        return result;
    }
    render() {
        return (
            <Container shown={this.props.showContainer}>
                <div>
                    <CommentTopBar
                        commentCount={this.props.commentCount}
                        showAddBtn={this.state.isMainFormActive}
                        onAddBtnClick={this.showMainForm}
                    />
                    <CommentForm
                        isActive={this.state.isMainFormActive}
                        isValid={this.state.formState.valid}
                        handleChange={this.handleInputChange}
                        inputName={this.state.inputName}
                        inputTitle={this.state.inputTitle}
                        inputContent={this.state.inputContent}
                        handleSubmit={this.handleSubmit}
                    />
                </div>
                <div>
                    <CommentList
                        comments={this.props.comments}
                        articleRef={this.props.articleRef}
                    />
                </div>
                <LoadCommentsContainer state={this.props.showMoreCommentsState}>
                    <LoadButton onClick={this.props.onLoadMoreClick}>
                        <LoadIcon>
                            <img src={reloadIcon} alt="" />
                        </LoadIcon>
                        <span>טען תגובות נוספות</span>
                    </LoadButton>
                </LoadCommentsContainer>
            </Container>
        )
    }
}

export default Comments;


// WEBPACK FOOTER //
// ./src/Components/comments/Comments.jsx